import {
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_INCLUDE_ARCHIVED,
  FILTER_PERIOD,
  FILTER_BUSINESS_PARTNERS,
} from 'scenes/Trackers/Tracker/constants';
import { compareSchema } from 'scenes/Trackers/Tracker/schemas';

import {
  dateFNS,
  fromUTCToTimeZone,
  fromTimeZoneToUTC,
  toISOString,
} from '@gogame/intl-ts';

export const getTrackerParams = ({
  period: _period,
  affiliates,
  businessPartner,
  details,
} = {}) => {
  let period = null;
  let isSameMonth = false;

  if (_period) {
    const localPeriod = fromUTCToTimeZone(_period) || [];
    const normalizedPeriod = [
      localPeriod[0],
      localPeriod[1] || dateFNS.startOfDay(new Date()),
    ];

    isSameMonth = dateFNS.isSameMonth(...normalizedPeriod);
    if (!dateFNS.isBefore(normalizedPeriod[1], normalizedPeriod[0])) {
      period = toISOString(fromTimeZoneToUTC(normalizedPeriod)) || [];
    }
  }
  const applicationIds =
    details?.map(({ application }) => application.id) || [];
  const affiliateIds = affiliates?.map(({ id }) => id);

  const filtersCollection = [
    {
      ...(businessPartner
        ? { [FILTER_BUSINESS_PARTNERS]: [businessPartner.id] }
        : {}),
      [FILTER_AFFILIATES]: affiliateIds,
      [FILTER_APPLICATIONS]: applicationIds,
      [FILTER_INCLUDE_ARCHIVED]: true,
      [FILTER_PERIOD]: period,
    },
  ];

  if (isSameMonth) {
    filtersCollection.unshift(
      compareSchema.cast(filtersCollection[0], {
        stripUnknown: true,
        context: {},
      })
    );
  }

  return {
    filtersCollection,
    ready: true,
  };
};
